import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type CardTitleComponentProps = {};

export type CardTitleProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, CardTitleComponentProps, "div" | "h2" | "h5">;

const CardTitle = <T extends React.ElementType = "div">({
    tag,
    className,
    ...attributes
}: CardTitleProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const classes = cn(className, "card-title");

    return (
        <Tag
            {...attributes}
            className={classes}
        />
    );
};

export { CardTitle };
